import { activeOnboarding } from '../activeOnboarding';
import type { SupportedFeatureIds } from '../types';

export const getUniqueFeatureId = (id: SupportedFeatureIds): string => activeOnboarding[id].id;
